import { CommonModule, NgClass, NgForOf, NgIf, NgTemplateOutlet } from "@angular/common";
import { AfterViewInit, Component, DoCheck, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ColumnDto, TableDto} from "src/app/core/models/generic/table-config.dto";
import { StatusHelper } from "../../helpers/status.helper";
import { SendInfoComponentService } from "src/app/core/services/local/send-info.component.service";
import { SelectionModel } from "@angular/cdk/collections";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TablePaginatorIntl } from "../../intl/table-paginator-intl";
import { WorkplaceStorageService } from "src/app/core/services/local/workplaces-storage.service";
import { MatButtonModule } from "@angular/material/button";
import moment from "moment";
import { StringUtilsHelper } from "../../helpers/strings.helper";
import { ArrayHelper } from "../../helpers/array.helper";
import { animate, state, style, transition, trigger } from "@angular/animations";

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgForOf,
        NgClass,
        NgTemplateOutlet,
        CommonModule,
        MatCheckboxModule,
        MatTableModule,
        MatSortModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatPaginatorModule
    ],
    providers: [
        { provide: MatPaginatorIntl, useClass: TablePaginatorIntl }
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class TableComponent implements OnInit, DoCheck, AfterViewInit  {
    @Input() tableDto: TableDto;
    @Input() msgNoData: string;
    @Input() listSelected?: any[];
    @Output() selectEvent = new EventEmitter<any>();
    @Output() editEvent = new EventEmitter<any>();
    @Output() deleteEvent = new EventEmitter<any>();
    @Output() actionEvent = new EventEmitter<any>();
    dataSource = new MatTableDataSource([]);
    listData: any[] = [];
    selection = new SelectionModel(true, []);
    selectedRow: any;

    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    displayColumns: string[] = [];
    labelColumns: string[] = [];

    colN: number = 0;
    cve: string;
    columnAction: string = "";
    clickButtonEdit: boolean = false;

    constructor(private sendInfo: SendInfoComponentService, @Inject(LOCALE_ID) public locale: string){

    }

    ngDoCheck(): void {        
        if(this.tableDto != undefined){
            this.listData = this.tableDto.list;
            if (this.tableDto.update || (this.tableDto.flagBtn && !this.clickButtonEdit)) {
                this.labelColumns = this.getHeaders(this.tableDto.columns, true);
                this.displayColumns = this.getHeaders(this.tableDto.columns);
                this.tableDto.update = false;
                this.paginator.firstPage();
                
                this.dataSource = new MatTableDataSource(this.tableDto.list);
                this.dataSource.sortData = (data: any[], sort: MatSort): any[] => {
                    if (!sort.active || sort.direction === '') {
                        return data;
                    }
    
                    return data.sort((a: any, b: any) => {
                        let aValue = this.getRowValue(sort.active, a);
                        let bValue = this.getRowValue(sort.active, b);
    
                        aValue = (aValue || '').toString().toLowerCase();
                        bValue = (bValue || '').toString().toLowerCase();
    
                        if (aValue < bValue) {
                            return sort.direction === 'asc' ? -1 : 1;
                        }
                        if (aValue > bValue) {
                            return sort.direction === 'asc' ? 1 : -1;
                        }
                        return 0;
                    });
                };
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
            this.clickButtonEdit = this.tableDto.flagBtn;
    
            this.cve = WorkplaceStorageService.getLanguageCve();
            switch (this.cve) {
                case "en":
                    this.columnAction = "Actions";
                    break;
                case "pt":
                    this.columnAction = "Ações"
                    break;
                default:
                    this.columnAction = "Acciones"
                    break;
            }
            if (this.tableDto.changed) {
                this.tableDto.changed = false;
                this.dataSource.data.forEach(row => {
                    let listOfSelected: any[] = [];
                    if (StringUtilsHelper.notNullOrUndefinedOrEmpty(ArrayHelper.getCards()) && ArrayHelper.getCards().length > 0) {
                        listOfSelected = ArrayHelper.getCards();
                        let exist = listOfSelected.find(x => x.id === row.id);
                        if (!StringUtilsHelper.notNullOrUndefinedOrEmpty(exist)) {
                            this.selection.deselect(row);
                        }
                    } else  {
                        listOfSelected = this.listSelected;
                        let exist = listOfSelected.find(x => x.id === row.id);
                        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(exist)) {
                            this.selection.select(row);
                        }
                    }
                    
                });
                if(this.selection.selected.length === 1)
                    this.sendRowsSelected(this.selection.selected, true);
            }
        }
    }

    ngOnInit(): void {
        ArrayHelper.setCards(this.selection.selected);
        if(this.tableDto != undefined){
            this.tableDto.update = false;
            this.colN = this.createLongColumnNoData(this.tableDto.columns.length, this.tableDto);
            this.labelColumns = this.getHeaders(this.tableDto.columns, true);
            this.displayColumns = this.getHeaders(this.tableDto.columns);
            
            this.dataSource = new MatTableDataSource(this.tableDto.list);
            this.dataSource.sortData = (data: any[], sort: MatSort): any[] => {
                if (!sort.active || sort.direction === '') {
                    return data;
                }

                return data.sort((a: any, b: any) => {
                    let aValue = this.getRowValue(sort.active, a);
                    let bValue = this.getRowValue(sort.active, b);

                    aValue = (aValue || '').toString().toLowerCase();
                    bValue = (bValue || '').toString().toLowerCase();

                    if (aValue < bValue) {
                        return sort.direction === 'asc' ? -1 : 1;
                    }
                    if (aValue > bValue) {
                        return sort.direction === 'asc' ? 1 : -1;
                    }
                    return 0;
                });
            };
        }
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.tableDto.update = true;

        if (this.sort) {
            this.sort.sortChange.subscribe(() => {
                this.dataSource.sort = this.sort;
            });
        }
    }

    createLongColumnNoData(length: number, objTable: TableDto){
        let n = length + 1;
        if (objTable.withDeleteAction || objTable.withEditAction || objTable.withButtonToggle) {
            n += 1
        }
        return n;
    }

    getRowValue = (key: any, row: any, isDate?: boolean, format?: string) => {
        let data = "";
        let keys = key.split('.');
        if (keys.length === 1) {
            data = row[key];
        } else {
            data = this.getDataRowCompound(row, keys);
        }
        if (key === 'status') {
            if (typeof data === 'number') {
                data = StatusHelper.getStatusById(Number(data));
            }
        } else if (isDate) {
            let dateMoment: moment.Moment = moment(data);
            if (StringUtilsHelper.notNullOrUndefinedOrEmpty(format)) {
                data = dateMoment.format(format);
            } else {
                data = dateMoment.format('L');
            }
        }
        return data;
    }

    getHeaders = (columns: ColumnDto[], isLabel?: boolean): string[] => {
        let headers: string[] = [];
        if (this.tableDto.withSelectCheck && !isLabel){
            headers.push("select");
            headers.splice(1, 0, "#");
        } else if(!isLabel)
            headers.splice(0, 0, "#");

        for (let column of columns){
            headers.push(isLabel ? column.label : column.key);
        }
        if (this.tableDto.flagBtn && (this.tableDto.withEditAction || this.tableDto.withDeleteAction || this.tableDto.withButtonToggle)){
            headers.push("action");
        }
        
        return headers;
    }
    onDelete = (row: any) => {
        this.selectedRow = row;
        if (this.tableDto.withDeleteFunc) {
            this.sendInfo.onClickDelete(row, this.tableDto.keyDelete);
        }
        this.tableDto.list = this.listData.filter(item => item !== row);
        this.listData = this.tableDto.list;
        this.dataSource = new MatTableDataSource(this.listData);
        this.dataSource.paginator = this.paginator;
        this.deleteEvent.emit(this.listData);
    }
    onEdit = (row: any) => {
        this.selectedRow = row;
        this.editEvent.emit(row);
    }
    onSelect = (row: any) => {
        if (this.tableDto.withSelectCheck) {
            this.selection.toggle(row);
            this.sendRowsSelected(this.selection.selected, !this.selection.isEmpty());
        } else {
            this.selectedRow = row;
            this.sendRowsSelected(row, true);
        }
    }
    sendRow(obj: any) {
        this.selectEvent.emit(obj);
    }

    onClick(row: any, active: boolean){
        row.isActive = active;
        this.actionEvent.emit(row);        
    }

    private getDataRowCompound(row: any, keys: any[]){
        let data = "";
        let obj = {};
        if (keys.length === 1) {
            data = row[keys[0]];
        } else {
            obj = row[keys[0]];
            data = this.getDataRowCompound(obj, keys.slice(1));
        }
        return data;
    }

    getClassToMap(key: string, param: any){
        if (typeof(param) === "string") {
            return param;
        } else {
            return param.get(key);
        }
    }
    getParamTemplate(param: string, key: string, value: any, onlyValue: boolean){
        let val: any;
        if (onlyValue) {
            val = "\"" + this.getRowValue(key, value) + "\"";
        } else {
            val = JSON.stringify(value);
        }
        let obj = "{\"" + param + "\":" + val + "}";
        let json = JSON.parse(obj);
        
        return json;
    }

    toggleAllRows() {
        let isActive: boolean;
        if (this.isAllSelected()) {
            this.selection.clear();
            isActive = false;
        } else {
            this.dataSource.data.forEach(row => this.selection.select(row));
            isActive = true;
        }
        this.sendRowsSelected(this.selection.selected, isActive);       
        ArrayHelper.setCards(this.selection.selected);
    }

    onCheckRowChange($event, row): void {       
        this.selection.toggle(row);
        ArrayHelper.setCards(this.selection.selected);
        this.sendRowsSelected(this.selection.selected, !this.selection.isEmpty());
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    private sendRowsSelected(data: any, isSelected: boolean){
        this.sendRow({
            row: data,
            flagCard: !isSelected
        });
    }

    expandedRow(data: any){
        if(StringUtilsHelper.notNullOrUndefinedOrEmpty(data))
            return "expanded";
        return "collapsed";
    }

    printName(obj: any, key: string = "fullName"){
        if(StringUtilsHelper.notNullOrUndefinedOrEmpty(obj))
            return obj[key];
        return "";
    }
    isFusedPatient(obj: any){
        if(StringUtilsHelper.notNullOrUndefinedOrEmpty(obj))
            return obj.isFused;
        return false;
    }
}